module.exports = __webpack_public_path__ + "img/b12.b37b638d.jpeg";